<template src="./quiz-results.html"></template>
<script>
import quizService from "../../services/quiz-service";
import appHeader from "../../../shared-module/components/app-header/app-header.vue";
var chevronListBox;
var feedback = false;
import { exportToCSV } from "./../../services/csvService";
export default {
  name: "app-quiz-results",
  components: {
    "app-header": appHeader,
  },
  data: () => {
    return {
      feedback,
      quizId: "",
      sessionId: "",
      searchResults: "",
      userName: "",
      instituteName: "",
      userEmail: "",
      userSearchResults: "",
      searchFlag: true,
      quizName: "",
      quizDuration: "",
      countQuestions: "",
      totalMarks:0,
      quizType: "",
    };
  },
  async mounted() {
    if (this.$route.query.sessionId) {
      this.sessionId = this.$route.query.sessionId;
      this.getResultsBySessionId();
    } else if (this.$route.query.quizId) {
      this.quizId = this.$route.query.quizId;
      try {
        const metaResp = await quizService.getQuizMeta(this.quizId);
        if (metaResp?.data?.data?.quiz?.quiz_type === "omr") {
          await this.$router.replace({
            path: "/quiz/omr-quiz-results",
            query: { quizId: this.quizId },
          });
          return;
        }
      } catch (error) {
        console.error(error);
      }
      this.getResultsByQuizId();
    }
  },
  computed: {
    activeResults() {
      if (this.searchFlag) return this.searchResults || [];
      return this.userSearchResults || [];
    },
    omrSummary() {
      if (this.quizType !== "omr") return null;
      const list = this.activeResults;
      if (!list.length) return null;
      let accSum = 0;
      let accCount = 0;
      let passCount = 0;
      list.forEach((r) => {
        const acc = Number(r.correct_percentage);
        if (Number.isFinite(acc)) {
          accSum += acc;
          accCount += 1;
        }
        if (r.result === true) passCount += 1;
      });
      const first = list[0];
      const passing = first && first.quiz && first.quiz.passing_percentage
        ? Number(first.quiz.passing_percentage)
        : 0;
      return {
        attempts: list.length,
        avgAccuracy: accCount ? (accSum / accCount).toFixed(1) : "0.0",
        passRate: list.length ? Math.round((passCount / list.length) * 100) : 0,
        passCount,
        passing,
      };
    },
  },
  methods: {
    async getCountOfQuesstions() {
      try {
        let response = await quizService.getQuizQuestionCount(this.quizId);
        this.countQuestions = response.data.data.question;
      } catch (error) {
        console.error(error);
      }
    },
    chevronListBoxHandler() {
      this.chevronListBox = !this.chevronListBox;
    },
    async getSessionByQuizId() {
      try {
        let response = await quizService.getSessionsByQuizId(this.quizId);

        let minuts = response.data.data.sessions[0].quiz_id.duration;
        let minutes = Math.floor(minuts / 60);
        this.quizDuration = minutes;
        this.sessionId = response.data.data.sessions[0]._id;
        this.getResultsBySessionId();
      } catch (error) {
        console.error(error);
      }
    },
    async getResultsBySessionId() {
      try {
        let response = await quizService.getResultsBySessionId(this.sessionId);
        this.searchResults = response.data.data.results;
        this.quizName = response.data.data.results[0].quiz.name;
        this.countQuestions = response.data.data.results[0].questions.length;
      } catch (error) {
        console.error(error);
        this.$toast.error("Results Not Found");
      }
    },
    async getResultsByQuizId() {
      try {
        let response = await quizService.getResultsByQuizId(this.quizId);
        const quizType = response.data.data.quiz_type
          || (response.data.data.results[0] && response.data.data.results[0].quiz
            && response.data.data.results[0].quiz.quiz_type)
          || "";
        if (quizType === "omr") {
          await this.$router.replace({
            path: "/quiz/omr-quiz-results",
            query: { quizId: this.quizId },
          });
          return;
        }
        this.quizType = quizType;
        if (!response.data.data.results || !response.data.data.results.length) {
          this.$toast.error("Results Not Found");
          return;
        }
        this.searchResults = response.data.data.results;
        this.totalMarks = response.data.data.totalMarks;
        this.countQuestions = response.data.data.question_count || this.totalMarks;
        this.quizName = response.data.data.results[0].quiz.name;
        this.searchResults = response.data.data.results.sort((a, b) => {
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return dateB - dateA;
        });
      } catch (error) {
        console.error(error);
        this.$toast.error("Results Not Found");
      }
    },
    searchFlagHandler(args) {
      if (args === 1) {
        this.searchFlag = false;
      } else {
        this.searchFlag = true;
      }
    },
    async searchUser(key) {
      try {
        let data = { quiz_id: this.quizId };
        data["keyword"] = this[key];
        data["key"] = key;
        let response = await quizService.searchUser(data);
        if (response) {
          this.userSearchResults = response.data.data.response;
          this.searchFlagHandler(1);
          this.userName = "";
          this.instituteName = "";
          this.userEmail = "";
        }
      } catch (error) {
        this.$toast.error("Search not Found!");
      }
    },
    exportCSV(x) {
  // if (!x) return;
   // Validate input
  
  console.log(this.searchFlag);
  const results = [];
  const headers = [
    "Student ID",
    "Signup Date",
    "Student Name",
    "Email",
    "Phone",
    "Total Obtained Marks",
    "Obtained Marks Percentage",
    "Date",
    "City",
    "Institute",
    "Time/Question",
    "Obtained Marks",
    "Skipped Count",
    "Marked Questions",
    "Result",
  ];
  results.push(headers);

  const d_to_iterate = this.searchFlag
    ? this.searchResults
    : this.userSearchResults;
  console.log(d_to_iterate);

  if (!d_to_iterate || d_to_iterate.length === 0) {
    console.error("No data to export.");
    return;
  }

  d_to_iterate.forEach((result, index) => {
    let city = "";
    let uni = "";
    let correct_percentage = 0;

    if (result.user?.city) {
      city = result.user.city.replace(/,/g, " ");
    }

    if (result.user?.university) {
      uni = result.user.university.replace(/,/g, " ");
    }

    if (result.correct_percentage) {
      correct_percentage = result.correct_percentage;
    }

    const skipped_count =
      result.skipped_questions.length > result.questions.length
        ? result.skipped_questions.length - 1
        : result.skipped_questions.length;

    let data = [
      result.user.id || "",
      result.user.created_at || "",
      result.user.full_name || "",
      result.user.email || "",
      result.user.phone || "",
      result?.marks_obtained, // Rounded to two decimal places
      correct_percentage || 0,
      result.created_at || "",
      city,
      uni,
      result.time_spent || "",
      result.obtained_marks || "",
      skipped_count || 0,
      result.marked_questions.length || 0,
      result.result ? "pass" : "fail",
    ];
    results.push(data);
    console.log(data);
  });

  // Export results to CSV
  const csvContent = results.map(row => row.join(",")).join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", "export.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
,
    gotoResult(result) {
      const quiz = result.quiz;
      if (quiz.quiz_type === "daq") {
        this.$router.push("/quiz/individual-results-daq?resultId=" + result._id);
      } else if (quiz.quiz_type === "omr" || result.is_omr_submission) {
        this.$router.push("/quiz/individual-results-omr?resultId=" + result._id);
      } else {
        this.$router.push("/quiz/individual-results?resultId=" + result._id);
      }
    },
    marksPercent(result) {
      if (result.correct_percentage != null && (this.quizType === "omr" || result.is_omr_submission)) {
        return Number(result.correct_percentage).toFixed(2);
      }
      if (!this.totalMarks) return "0";
      const marks = result.marks_obtained != null ? result.marks_obtained : 0;
      return ((marks / this.totalMarks) * 100).toFixed(2);
    },
    timePerQuestion(result) {
      const count = (result.questions && result.questions.length)
        || result.total_marks
        || (result.quiz && result.quiz.question_count)
        || this.countQuestions
        || 1;
      const spent = Number(result.time_spent) || 0;
      return (spent / count).toFixed(2);
    },
  },
};
</script>

<style src="./quiz-results.css" scoped></style>
